import React from 'react';

const CheckIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86009 17.9999C9.72297 17.9995 9.58741 17.9708 9.46183 17.9158C9.33624 17.8607 9.22333 17.7804 9.13009 17.6799L4.27009 12.5099C4.08841 12.3163 3.99109 12.0585 3.99953 11.7931C4.00797 11.5277 4.12148 11.2766 4.31509 11.0949C4.50869 10.9132 4.76654 10.8159 5.03191 10.8244C5.29727 10.8328 5.54841 10.9463 5.73009 11.1399L9.85009 15.5299L18.2601 6.32991C18.3454 6.22363 18.4516 6.13593 18.5721 6.07217C18.6926 6.00842 18.8248 5.96997 18.9607 5.95919C19.0966 5.94841 19.2332 5.96551 19.3622 6.00946C19.4912 6.05341 19.6099 6.12327 19.711 6.21476C19.812 6.30624 19.8933 6.41742 19.9498 6.54145C20.0063 6.66549 20.0369 6.79977 20.0396 6.93605C20.0423 7.07233 20.0172 7.20772 19.9657 7.33392C19.9141 7.46012 19.8374 7.57446 19.7401 7.66991L10.6001 17.6699C10.5077 17.7723 10.3952 17.8544 10.2696 17.9112C10.144 17.968 10.0079 17.9982 9.87009 17.9999H9.86009Z"
        fill="currentFill"
      />
    </svg>
  );
};

export default CheckIcon;
